import { render, staticRenderFns } from "./GameComponent.vue?vue&type=template&id=87e850e6&scoped=true"
import script from "./GameComponent.vue?vue&type=script&lang=js"
export * from "./GameComponent.vue?vue&type=script&lang=js"
import style0 from "./GameComponent.vue?vue&type=style&index=0&id=87e850e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e850e6",
  null
  
)

export default component.exports